export default __webpack_public_path__ + "static/media/YAHOO_MANUAL.02573b63.png";